/* eslint-disable
    func-names,
    guard-for-in,
    no-console,
    no-restricted-syntax,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

const { gql } = require('@apollo/client');

const GET_CONVERSATIONS_ATTACHED_TO_ID = gql`
  query Conversation($clientId: ID!, $attachedToId: ID!) {
    client(id: $clientId) {
      id
      conversations(attachedToId: $attachedToId) {
        id
        attachedTo
        comments {
          data {
            authorId
            authorName
            authorEmail
            date
            body
            editAuthorId
            editAuthorName
            editAuthorEmail
            edited
          }
        }
      }
    }
  }
`;

const deps = ['GatewayApi', 'Model', 'ConversationVM'];

const factory = function (GatewayApi, Model, ConversationVM) {
  let Conversation;
  return (Conversation = (function () {
    Conversation = class Conversation extends Model {
      static initClass() {
        this.prototype.id = null;
        this.prototype.attachedTo = null;
        this.prototype.comments = [];
        this.prototype.$viewModelType = ConversationVM;
        this.prototype.$apiService = GatewayApi;
      }
      $url() {
        return `conversations/${this.id}`;
      }

      $fetch() {
        const query = gql`
          query Conversation($conversationId: ID!) {
            conversation(id: $conversationId) {
              id
              attachedTo
              comments {
                data {
                  authorId
                  authorName
                  authorEmail
                  date
                  body
                  editAuthorId
                  editAuthorName
                  editAuthorEmail
                  edited
                }
              }
            }
          }
        `;

        const variables = { conversationId: this.$storeId() };

        return this.$graphqlClient.query({ query, variables }).then(res => {
          this.$set(this.$$transformGQLResponse(res.data.conversation));
          return this.$cache();
        });
      }

      $fetchByAttachment() {
        const variables = { clientId: this.clientId, attachedToId: this.attachedTo };
        return this.$graphqlClient
          .query({ query: GET_CONVERSATIONS_ATTACHED_TO_ID, variables })
          .then(res => {
            // Not a great design here, but it's implicit in this part of the system that there
            // will be 1 conversation per client/attachedToId. This is not true elsewhere.
            // Mainapp exposes an endpoint that returns a single conversation,
            // but it just returns the first element.
            if (res.data.client.conversations.length !== 0) {
              this.$set(this.$$transformGQLResponse(res.data.client.conversations[0]));
            }
            return this.$cache();
          });
      }

      $new(comment) {
        const mutation = gql`
          mutation create($clientId: ID!, $attachedToId: ID!, $commentBody: String!) {
            createConversation(
              attachedToId: $attachedToId
              clientId: $clientId
              commentBody: $commentBody
            ) {
              id
              attachedTo
              comments {
                data {
                  authorId
                  authorName
                  authorEmail
                  date
                  body
                  editAuthorId
                  editAuthorName
                  editAuthorEmail
                  edited
                }
              }
            }
          }
        `;

        const mutationVariables = {
          clientId: this.clientId,
          attachedToId: this.attachedTo,
          commentBody: comment,
        };
        const refetchVariables = { clientId: this.clientId, attachedToId: this.attachedTo };

        return this.$graphqlClient
          .mutate({
            mutation,
            variables: mutationVariables,
            refetchQueries: [
              { query: GET_CONVERSATIONS_ATTACHED_TO_ID, variables: refetchVariables },
            ],
          })
          .then(res => {
            this.$setId(res.data.createConversation.id);
            return new this.constructor(this.$$transformGQLResponse(res.data.createConversation));
          });
      }

      $post(comment) {
        const mutation = gql`
          mutation reply($conversationId: ID!, $commentBody: String!) {
            replyToConversation(conversationId: $conversationId, commentBody: $commentBody) {
              id
              attachedTo
              comments {
                data {
                  authorId
                  authorName
                  authorEmail
                  date
                  body
                  editAuthorId
                  editAuthorName
                  editAuthorEmail
                  edited
                }
              }
            }
          }
        `;

        const variables = { conversationId: this.id, commentBody: comment };
        return this.$graphqlClient
          .mutate({ mutation, variables })
          .then(
            res => new this.constructor(this.$$transformGQLResponse(res.data.replyToConversation)),
          );
      }

      $$transformGQLResponse(response) {
        return {
          ...response,
          comments: response.comments.data,
        };
      }

      $editComment(commentIndex, body) {
        const comment = this.comments[commentIndex];
        if (comment == null) {
          console.error('Comment does not exist in id: ', this.id, 'comment index:', commentIndex);
          return;
        }

        const mutation = gql`
          mutation editComment(
            $conversationId: ID!
            $originalAuthor: String!
            $originalDate: RFC3339Date!
            $body: String!
          ) {
            editComment(
              conversationId: $conversationId
              originalAuthor: $originalAuthor
              originalDate: $originalDate
              body: $body
            ) {
              id
              attachedTo
              comments {
                data {
                  authorId
                  authorName
                  authorEmail
                  date
                  body
                  editAuthorId
                  editAuthorName
                  editAuthorEmail
                  edited
                }
              }
            }
          }
        `;
        const originalDate =
          typeof comment.date === 'number'
            ? new Date(comment.date * 1000).toISOString()
            : comment.date;

        const variables = {
          conversationId: this.id,
          body,
          originalAuthor: comment.authorId,
          originalDate,
        };
        return this.$graphqlClient
          .mutate({ mutation, variables })
          .then(res => new this.constructor(this.$$transformGQLResponse(res.data.editComment)));
      }
    };
    Conversation.initClass();
    return Conversation;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name, require('data/viewModel/conversation').name];

module.exports = angular
  .module('bench.data.model.conversation', moduleDeps)
  .factory('Conversation', factory);
